import ReactGA from 'react-ga';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MEASUREMENT_ID = 'G-TX9B7MQ1XM';

export const ANALYTICS_CATEGORIES = {
  ELECTIONS: 'ELECTIONS',
  RACES: 'RACES',
  CANDIDATES: 'CANDIDATES',
};

export const ANALYTICS_ACTIONS = {
  SET: 'SET',
};

// the following is adopted from: https://raptis.wtf/blog/custom-hook-to-connect-google-analytics-in-react/

function init() {
  // Enable debug mode on the local development environment
  const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
  ReactGA.initialize(MEASUREMENT_ID, { debug: isDev });
}

export function sendEvent(category, action) {
  ReactGA.event({ category, action });
}

function sendPageView(path) {
  ReactGA.set({ page: path });
  ReactGA.pageview(path);
}

export default function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(init, []);

  useEffect(() => {
    if (location) sendPageView(location.pathname + location.search);
  }, [location]);
}
